import { Card, mq } from 'plume-ui'
import { css } from '@emotion/react'

type Props = {
  children: React.ReactNode
}

export const DoubleColumnContent: React.FC<Props> = (props) => {
  return (
    <Card.Content
      css={css`
        padding: 32px !important;
        display: flex;
        flex-direction: column;
        ${mq.large} {
          flex-direction: row;
          > dl {
            width: 50%;
            &:last-of-type {
              padding-left: 1rem;
            }
          }
        }
      `}
    >
      {props.children}
    </Card.Content>
  )
}
